'use client'

import { useEffect, useState } from 'react'
import Image from 'next/image'

import { cn } from '@/lib/utils'

const SLIDES = ['/images/slide-1.png', '/images/slide-2.png', '/images/slide-3.png']
const INTERVAL_MS = 4000

export function CompanyMetricsSlider() {
  const [active, setActive] = useState(0)

  useEffect(() => {
    const id = setInterval(() => {
      setActive((prev) => (prev + 1) % SLIDES.length)
    }, INTERVAL_MS)
    return () => clearInterval(id)
  }, [])

  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-lg border border-gray-200 shadow-sm lg:col-span-7">
      {SLIDES.map((src, index) => (
        <Image
          key={src}
          src={src}
          alt=""
          fill
          sizes="(min-width: 1024px) 58vw, 100vw"
          priority={index === 0}
          className={cn(
            'object-cover transition-opacity duration-700',
            index === active ? 'opacity-100' : 'opacity-0'
          )}
        />
      ))}

      <div className="absolute bottom-4 left-1/2 z-10 flex -translate-x-1/2 gap-2">
        {SLIDES.map((src, index) => (
          <button
            key={src}
            type="button"
            aria-label={`Slide ${index + 1}`}
            onClick={() => setActive(index)}
            className={cn(
              'h-2 rounded-full transition-all',
              index === active ? 'w-6 bg-white' : 'w-2 bg-white/50'
            )}
          />
        ))}
      </div>
    </div>
  )
}
